import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import RTLLayout from 'layouts/rtl';
import AdminLayout from 'layouts/admin';
import AuthLayout from 'layouts/auth';
import PublicLayout from 'layouts/public';
import BackOfficeLayout from 'layouts/backoffice';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'assets/css/Plugins.css';
import GuessAccess from 'views/admin/guess';
import GuestSellerAccess from 'views/admin/guess-seller';
import Impersonate from 'views/admin/impersonate';
import Manager from 'views/admin/manager';
import { captureReferralCodeFromUrl } from 'utils/referral';
import { fetchIndustries } from 'services/industryService';

const App = () => {
    const token = localStorage.getItem('token');
    const isAuthenticated = !!token && token.length > 10;
    const location = useLocation();

    useEffect(() => {
        captureReferralCodeFromUrl(location.search);
    }, [location.search]);

    useEffect(() => {
        // Warm the industries cache so admin-configured sub-industry images
        // (see variables/images.ts) are available by the time offer cards render
        fetchIndustries().catch(() => {});
    }, []);

    return (
        <GoogleOAuthProvider clientId="447127369441-1153im5j42ag08bdm5k1jm40400j8bh1.apps.googleusercontent.com">
            <Routes>
                <Route path="auth/*" element={<AuthLayout />} />
                <Route
                    path="admin/*"
                    element={
                        isAuthenticated ? (
                            <AdminLayout />
                        ) : (
                            <Navigate to="/auth/sign-in" replace />
                        )
                    }
                />
                <Route path="back-office/*" element={<BackOfficeLayout />} />
                <Route path="rtl/*" element={<RTLLayout />} />
                <Route path="public/*" element={<PublicLayout />} />
                <Route path="/guest/:id" element={<GuessAccess />} />
                <Route path="/guest-seller/:id" element={<GuestSellerAccess />} />
                <Route path="/impersonate" element={<Impersonate />} />
                <Route path="/manager" element={<Navigate to="/back-office" replace />} />
                <Route path="/manager/:id" element={<Manager />} />
                <Route
                    path="/"
                    element={
                        <Navigate
                            to={
                                isAuthenticated
                                    ? '/dashboard'
                                    : '/auth/sign-in'
                            }
                            replace
                        />
                    }
                />
                <Route
                    path="/*"
                    element={
                        isAuthenticated ? (
                            <AdminLayout />
                        ) : (
                            <Navigate to="/auth/sign-in" replace />
                        )
                    }
                />
            </Routes>
        </GoogleOAuthProvider>
    );
};

export default App;
